import axiosInstance from "../utils/axios";
import { URL } from "../utils/axios";

const API_URL = `${URL}/api/leads`;

// Create a new lead (public, contact form submission)
export const createLead = async (leadData) => {
    try {
        const response = await axiosInstance.post(API_URL, leadData);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Fetch all leads (authenticated)
export const fetchLeads = async () => {
    try {
        const response = await axiosInstance.get(API_URL);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Fetch a single lead by ID (authenticated)
export const fetchLeadById = async (id) => {
    try {
        const response = await axiosInstance.get(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};

// Delete a lead (authenticated)
export const deleteLead = async (id) => {
    try {
        const response = await axiosInstance.delete(`${API_URL}/${id}`);
        return response.data;
    } catch (error) {
        throw error;
    }
};
